import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import {  allowdConductorNo, allowdDriverNo, allowedCompaniesPickUpName } from '../../constant';

const BookingDetails = ({ tripDetails = {} }) => {
  const columnDef = [
    { name: 'Journey Date', value: (tripDetails.JourneyDate !== null && tripDetails.JourneyDate !== undefined) ? dayjs(tripDetails.JourneyDate, 'DD-MMM-YYYY').format('ddd, DD-MMM-YYYY') : '-' },
    { name: 'Bus Number', value: tripDetails?.BusMasterNumber || '' },
    { name: 'Operator', value: tripDetails?.B2CName || '' },
    { name: 'Trip Time', value: tripDetails?.TripTime || '' },
    { name: 'Service Name', value: tripDetails.ServiceName || '' },
    { name: 'Conductor Name', value: `${tripDetails.ConductorName || ''} ${allowdConductorNo.has(Number(tripDetails.CompanyID)) ? `(${tripDetails.ConductorContact || ''})` : ''}` },
    { name: 'Driver Name', value: `${tripDetails.driverName || ''} ${allowdDriverNo.has(Number(tripDetails.CompanyID)) ? `(${tripDetails.driverContactNo || ''})` : ''}` },
  ]

  if (allowedCompaniesPickUpName.has(Number(tripDetails.CompanyID))) {
    columnDef.push({ name: 'PickUp Man', value: `${tripDetails.pickupMan || ''}${tripDetails.pickupManContactNo ? `(${tripDetails.pickupManContactNo || ''})` : ''}` })
  }
  return (
    <Box className='details_Section'>
      {columnDef.map((obj) => (
        <Box className='details_list'>
          <Typography sx={{ width: '30%' }}>{obj.name}</Typography>
          <Typography>:</Typography>
          <Typography sx={{ width: '55%' }}>{obj.value}</Typography>
        </Box>
      ))}
    </Box>
  )
}

export default BookingDetails